import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import { useLocation } from 'react-router-dom';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import api from './../api.js';
import { site_url, invoice_img } from "./../config.js";
import { IndianCurrencyFormatter, FormatDate } from './../Function';
import Swal from 'sweetalert2';


export default function Index() {

    const queryParams = new URLSearchParams(useLocation().search);
    const id = queryParams.get('id');
    const [data, setdata] = useState([]);
    const paymentdetails = async () => {
        try {
            const response = await api.get('/vendor/paymentdetails/' + id);
            if (response.data.status == 'success') {
                setdata(response.data);
            }
        } catch (error) {

        }
    }
    useEffect(() => {

        paymentdetails();
    }, [id])
    const cancellbill = async () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!',
        }).then((result) => {
            if (result.isConfirmed) {
                // Perform your action here
                cancelrequesr();
                Swal.fire('cancelled!', 'Your item has been cancelled.', 'success');
            }
        });

    }
    const cancelrequesr = async () => {
        try {
            const response = await api.get('/cancelrequesr/' + id + '/1');
            if (response.data.status == 'success') {
                paymentdetails();
            }
        } catch (error) {

        }
    }
    return (
        <div>
            {data != '' ?
                <div className="row mt-2"><br></br>

                    <div className="col-12">

                        <div className="stat-box mt-2">
                            <center>
                                <img
                                    style={{ marginTop: '6%', width: '70px' }}
                                    src={invoice_img}
                                    alt="img"
                                    className="image-block imaged "
                                />
                            </center>
                            {data.billorder.is_paid == '1' && (
                                <>
                                    <br></br>
                                    <center>
                                        <a onClick={cancellbill} className='btn btn-danger'> Cancel This Bill</a>
                                    </center>
                                </>
                            )}

                            <h1 style={{ fontWeight: '700' }} className='mt-2'><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax))} /> </h1>

                            <b>{(data.billorder.date_time)}</b><br></br>
                            <br></br>
                            <b style={{ color: 'black' }}>Details</b>
                            <table className="table table-bordered">

                                <tbody>
                                    <tr>
                                        <th scope="col"><b>Token Number</b></th>
                                        <th scope="col"><b style={{ color: 'red', fontSize: '20px' }}>{data.billorder.token_no}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill ID</b></th>
                                        <th scope="col"><b>#{data.billorder.billno}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Customer Name</b></th>
                                        <th scope="col"><b>{data.customer.username}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Customer Phone</b></th>
                                        <th scope="col"><b>{data.customer.phone}</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Amount</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount))} /></b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Tax</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.tax))} /></b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Pay status</b></th>
                                        <th scope="col">
                                            <b>
                                                {data.billorder.is_paid == '0' && (
                                                    <span className="badge badge-success">Paid</span>
                                                )}
                                                {data.billorder.is_paid == '1' && (
                                                    <span className={`badge ${data.billorder.paytype === 'online' ? 'badge-warning' : 'badge-danger'}`}>
                                                        {data.billorder.paytype === 'online' ? 'Pending' : 'Unpaid'}
                                                    </span>
                                                )}
                                                {data.billorder.is_paid == '2' && (
                                                    <span className="badge badge-warning">Cancelled</span>
                                                )}
                                            </b>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Bill Type</b></th>
                                        <th scope="col"><b>
                                            {data.billorder.paytype == 'cash' ? (
                                                <span className="badge badge-success">Cash</span>
                                            ) : (
                                                <span className="badge badge-info">Online (Razorpay)</span>
                                            )}
                                        </b></th>
                                    </tr>
                                </tbody>
                            </table>
                            <br></br>
                            <b style={{ color: 'black' }}>Payment Details</b>
                            <br></br>
                            <table className="table table-bordered">

                                <tbody>

                                    <tr>
                                        <th scope="col"><b>Total Bill Amount</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax))} /></b></th>
                                    </tr>

                                    <tr>
                                        <th scope="col"><b style={{ color: 'red' }}>Admin Commission (Rate)</b></th>
                                        <th scope="col"><b>{data.billorder.admincommisition}%</b></th>
                                    </tr>
                                    <tr>
                                        <th scope="col"><b>Customer Reward Used</b></th>
                                        <th scope="col"><b><IndianCurrencyFormatter amount={parseFloat(data.billorder.customer_reward_used || 0)} /></b></th>
                                    </tr>
                                    {data.billorder.paytype === 'cash' && (
                                        <tr>
                                            <th scope="col"><b>Cash Collected by You</b></th>
                                            <th scope="col"><b><IndianCurrencyFormatter amount={(parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax)) - parseFloat(data.billorder.customer_reward_used || 0)} /></b></th>
                                        </tr>
                                    )}
                                    <tr>
                                        <th scope="col"><b style={{ color: 'red' }}>Total Commission Amount</b></th>
                                        <th scope="col">
                                            <b style={{ fontSize: '16px', color: 'black', fontWeight: '700' }}>
                                                <IndianCurrencyFormatter
                                                    amount={(() => {
                                                        const dbComm = parseFloat(data.billorder.admin_commission_amount);
                                                        if (dbComm > 0) return dbComm;
                                                        // Fallback logic for old bills or missing join data
                                                        const billTotal = parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax);
                                                        const rate = parseFloat(data.billorder.admincommisition);
                                                        return (billTotal * rate) / 100;
                                                    })()}
                                                />
                                            </b>
                                        </th>
                                    </tr>
                                    {data.billorder.customer_reward_used > 0 && (
                                        <tr className="bg-success-light">
                                            <th scope="col"><b style={{ color: '#28a745' }}>Admin Payout to You</b></th>
                                            <th scope="col">
                                                <b style={{ fontSize: '18px', color: '#28a745', fontWeight: '800' }}>
                                                    <IndianCurrencyFormatter
                                                        amount={(() => {
                                                            const reward = parseFloat(data.billorder.customer_reward_used);
                                                            const dbComm = parseFloat(data.billorder.admin_commission_amount);
                                                            const comm = (dbComm > 0) ? dbComm : ((parseFloat(data.billorder.billamount) + parseFloat(data.billorder.tax)) * parseFloat(data.billorder.admincommisition) / 100);
                                                            return Math.max(0, reward - comm);
                                                        })()}
                                                    />
                                                </b>
                                            </th>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <br></br>

                        </div>
                    </div>

                </div>

                :

                <div class="spinner-grow text-primary" role="status"></div>


            }
            <Footer />
            <Sidebar />

        </div>
    )
}
